export const formatMonthDay = (month: string, day: string) => {
	const paddedMonth = String(month).padStart(2, '0');
	const paddedDay = String(day).padStart(2, '0');

	return `--${paddedMonth}-${paddedDay}`;
};
export const parseMonthDay = (formatted: string) => {
	// Quitamos los guiones iniciales
	const cleaned = formatted.substring(2);
	const parts = cleaned.split('-');

	return {
		month: parseInt(parts[0]),
		day: parseInt(parts[1]),
	};
};

export const stringifyMonthDay = (formatted: string) => {
	// Quitamos los guiones iniciales
	const cleaned = formatted.substring(2);
	const parts = cleaned.split('-');

	return `${parts[0]}/${parts[1]}`;
};
